module.exports = __webpack_public_path__ + "img/restaurant-alt.e1eee783.webp";